import { Slider, InputNumber, Flex } from "antd"
import { useContext, useMemo } from "react"
import {
    CustomizeMoneyFlowContext,
    MoneyFlowContext,
} from "../../../context/MoneyFlowContext.tsx"

export const Threshold = () => {
    const { setThreshold } = useContext(CustomizeMoneyFlowContext)
    const { threshold, sankeyData } = useContext(MoneyFlowContext)

    const max = useMemo(
        () =>
            sankeyData?.Edges.reduce(
                (acc, link) => Math.max(acc, link.AmountUSD),
                0
            ) || 0,
        [sankeyData]
    )

    return (
        <>
            <Slider
                style={{ width: 200 }}
                onChange={(value) => setThreshold(value)}
                value={threshold}
                min={0}
                max={max}
                step={1}
            />
            <Flex gap={4} align="center">
        Threshold:
                <InputNumber
                    size="small"
                    prefix="$"
                    min={0}
                    max={max}
                    value={threshold}
                    onChange={(val) => setThreshold(val ?? 0)}
                />
            </Flex>
        </>
    )
}
